var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalLineDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 87,
    viewBox: "0 0 2 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: 1.03125,
    y1: 0.566406,
    x2: 1.03125,
    y2: 86.6982,
    stroke: "#AFBDD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLineDesktop);
export default __webpack_public_path__ + "static/media/vertical-line-desktop.2e4897e83111ad6308d0e70c8a445182.svg";
export { ForwardRef as ReactComponent };